import dayjs from 'dayjs';
import { DataModel } from './dto/dto.js';
import { BusinessModuleRef } from './serializable/business-module-ref.js';
import { Country } from './serializable/country.js';
import { Language } from './serializable/language.js';
import { TimeZoneRegion } from './serializable/time-zone-region.js';
import { EntityMixin } from '../components/core/entity-mixin.js';

export abstract class Discoverable extends EntityMixin(DataModel) {
  abstract get uniqueId(): string;
  abstract get creatorId(): string;
  abstract get creationDate(): dayjs.Dayjs;
  abstract get country(): Country;
  abstract get language(): Language;
  abstract get timezone(): TimeZoneRegion;
  abstract get businessRef(): BusinessModuleRef;
  abstract get webRoute(): string | null;
}
